module.exports = __webpack_public_path__ + "img/new-guide-04-1.4d71930b.png";